module.exports = __webpack_public_path__ + "static/after-fd1794d9bcca31480eeb37723a540c9c.png";